import { ReactNode } from "react"
import { Dropdown as AntDropdown } from "antd"
import type { MenuProps, DropDownProps } from "antd"

type Props = {
	className?: string
	items: MenuProps["items"]
	children: ReactNode
	onClick?: MenuProps["onClick"]
	open?: boolean
	onOpenChange?: DropDownProps["onOpenChange"]
	placement?: DropDownProps["placement"]
	overlayStyle?: React.CSSProperties
}

export const Dropdown = ({
	className = "",
	items,
	children,
	placement = "bottomRight",
	onClick,
	open,
	onOpenChange,
	overlayStyle,
}: Props) => {
	return (
		<div data-testid="dropdown">
			<AntDropdown
				destroyOnHidden
				className={className}
				overlayStyle={overlayStyle}
				menu={{ items, onClick }}
				placement={placement}
				open={open}
				onOpenChange={onOpenChange}
			>
				{children}
			</AntDropdown>
		</div>
	)
}
